import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const ImageLoad = React.memo(({ className = '', loadingClassName = '', src, placeholder, alt = '' }) => {
  const [loading, setLoading] = useState(true);
  const [currentSrc, updateSrc] = useState(placeholder);

  useEffect(() => {
    const imageToLoad = new Image();
    imageToLoad.src = src;
    imageToLoad.onload = () => {
      setLoading(false);
      updateSrc(src);
    }
  }, [src])

  return <img className={loading ? loadingClassName : className} src={currentSrc} alt={alt} />;
});

ImageLoad.propTypes = {
  className: PropTypes.string,
  loadingClassName: PropTypes.string,
  src: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
};

export default ImageLoad;